import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/verificationAccount.module.css';
import { useState } from 'react';
import { VerificationAccountHelper } from '../../helpers/auth/verification-account';
import { Helmet } from 'react-helmet';

const VerificationAccount: React.FC = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    formErrors,
    isProcessing,
  } = VerificationAccountHelper();

  const [emaphoActive, setEmaphoActive] = useState(false);
  const [otpActive, setOtpActive] = useState(false);

  return (
    <>
      <Helmet>
        <title>Account Verification - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Verify your account to start shopping on Mohit's Shopping App. Complete the verification process to unlock your full access."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Account Verification - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Verify your account and gain full access to all the features on Mohit's Shopping App. Start shopping and exploring the best deals."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/verification-account"
        />
      </Helmet>

      {/* Main Heading of the Account Verification Page */}
      <h1 className="visually-hidden">Account Verification - Verify Your Email or Account</h1>

      <section className={Styles.verificationAccountSec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-end ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.formWrapper}>
                <h1>Verification Account</h1>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Enter Email"
                      className={`${Styles.floatingLabel} ${emaphoActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Enter Email"
                        name="contact"
                        className={Styles.input}
                        autoComplete="off"
                        onFocus={() => setEmaphoActive(true)}
                        onBlur={(e) => setEmaphoActive(e.target.value !== '')}
                        value={values.contact}
                        onChange={handleChange}
                        disabled={isProcessing}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Enter OTP"
                      className={`${Styles.floatingLabel} ${otpActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        name="otp"
                        className={Styles.input}
                        autoComplete="off"
                        onFocus={() => setOtpActive(true)}
                        onBlur={(e) => setOtpActive(e.target.value !== '')}
                        value={values.otp}
                        onChange={handleChange}
                        disabled={isProcessing}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    type="submit"
                    className={Styles.verificationAccountBtn}>
                    {Object.keys(formErrors).length > 0 ? (
                      'Verify OTP'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner}
                      />
                    ) : (
                      'Verify OTP'
                    )}
                  </Button>
                  <p className={Styles.text}>
                    Please check your Email.
                  </p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default VerificationAccount;




// navigate('auth/verification-account');
// dispatch(resetAuth());